import { Injectable } from '@angular/core';
import { ProductSearchRequest } from '../../../models/quote/product-search-request';
import { map, Observable } from 'rxjs';
import { ProductsByServicesRequest } from '../../../models/quote/products-by-services-request';
import { ProductClassificationRequest } from '../../../models/quote/product-classification-request';
import { PriceList } from '../../../models/productv2/pricelist.model';
import { ProductWithChildrenV2 } from 'src/app/core/models/productv2/productv2-children.model';
import { Page } from 'src/app/core/utils/page';
import { ProductV2 } from 'src/app/core/models/productv2/productv2.model';
import { ProductMapperV2Service } from '../product-mapper-v2.service';

@Injectable()
export abstract class CmcProductManagerService {

    constructor(protected productMapper: ProductMapperV2Service) {
    }

    abstract searchArticles(productSearchRequest: ProductSearchRequest, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>>;

    abstract searchArticlesByFilteredElisCodes(requestData: ProductsByServicesRequest): Observable<{ content: ProductWithChildrenV2[] }>;
    abstract searchClassifications(productClassificationRequest: ProductClassificationRequest): Observable<PriceList[]>;

    searchArticlesForDuplication(requestData: ProductsByServicesRequest): Observable<{ service: string, products: ProductV2[] }[]> {
        return this.searchArticlesByFilteredElisCodes(requestData).pipe(
            map(products => this.productMapper.createDistinctProductV2List(products.content)),
            map(products => this.productMapper.groupProductsByService(products)),
            //return requested service with products even who doesnt have any product
            map((grouped) =>
                Object.keys(requestData.codesByService).map(s => {
                    const entry = grouped.find(g => g.service === s);
                    return {
                        service: s,
                        products: entry?.products ?? []
                    };
                })
            )
        );
    }



}
